import React, {useEffect,useState} from "react";
import { NavLink } from "react-router-dom";
import Brand from "./Brand";
import BusinessSwitcher from "./BusinessSwitcher";
import UserMenu from "./UserMenu";
import SafeIcon from "../common/SafeIcon";
import { accountantNavigationGroups, navigationGroups, resolveOwnerNavigationGroups } from "../data/navigation";
import {useBusiness} from '../contexts/BusinessContext';
import {preloadRoute} from '../routes/lazyPages';
import {usePlanAccess} from '../hooks/usePlanAccess';
import {useLanguage} from '../contexts/LanguageContext';
import {getBlogEditor} from '../lib/blog/blogService';
import {FiEdit3} from 'react-icons/fi';

function Sidebar({ session }) {
  const {activeAccess}=useBusiness();
  const {isMileagePlan,isPlanResolved}=usePlanAccess();
  const {t}=useLanguage();
  const [isBlogEditor,setIsBlogEditor]=useState(false);
  useEffect(()=>{let active=true;getBlogEditor().then(editor=>active&&setIsBlogEditor(Boolean(editor))).catch(()=>{});return()=>{active=false;};},[session?.user?.id]);
  const ownerGroups=resolveOwnerNavigationGroups(navigationGroups,{isMileagePlan,isPlanResolved});
  const groups=activeAccess?.mode==='accountant' ? accountantNavigationGroups : (isBlogEditor?[...ownerGroups,{label:'Publishing',items:[{label:'Blog studio',path:'/settings/blog',icon:FiEdit3}]}]:ownerGroups);
  return (
    <aside className="fixed inset-y-0 left-0 z-30 hidden w-[248px] border-r border-slate-200 bg-white px-4 py-5 lg:flex lg:flex-col">
      <Brand />

      <div className="mt-5">
        <BusinessSwitcher />
      </div>

      <nav
        className="mt-5 min-h-0 flex-1 space-y-5 overflow-y-auto pb-5"
        aria-label={t('Main navigation')}
      >
        {groups.map((group) => (
          <div key={group.label}>
            <p className="mb-1.5 px-3 text-[11px] font-semibold uppercase tracking-wider text-slate-500">
              {t(group.label)}
            </p>
            <div className="space-y-0.5">
              {group.items.map((item) => (
                <NavLink
                  key={item.label}
                  to={item.path}
                  end={item.path === "/"}
                  onMouseEnter={() => preloadRoute(item.path)}
                  onFocus={() => preloadRoute(item.path)}
                  className={({ isActive }) =>
                    `relative flex items-center gap-3 min-h-11 rounded-md px-3 py-2 text-sm font-medium transition-colors duration-150 ${
                      isActive
                        ? "bg-mint text-primary"
                        : "text-slate-600 hover:bg-gray-50 hover:text-gray-900"
                    }`
                  }
                >
                  <SafeIcon
                    icon={item.icon}
                    className="h-[18px] w-[18px] shrink-0"
                  />
                  {t(item.label)}
                </NavLink>
              ))}
            </div>
          </div>
        ))}
      </nav>

      <div className="border-t border-gray-100 pt-4 shrink-0">
        <UserMenu session={session} />
      </div>

      <p className="mt-5 text-xs text-gray-400">
        {t(activeAccess?.mode==='accountant' ? 'Secure read-only access' : 'A Silahub Technologies company')}
      </p>
    </aside>
  );
}

export default Sidebar;
